import {mix} from "@spa/utils/assetPathResolver";
import {memo} from "react";
import {trackPagingNext, trackPagingPrevious} from "@spa/features/search_job/pc/api/analytics/trackEvent";
import {useTrack} from "@spa/features/search_job/pc/contexts/TrackContext";

export const Pagination = memo(({
    hasPreviousPage,
    previousPageUrl,
    hasNextPage,
    nextPageUrl,
    pageCountDisplay,
    translations,
}) => {
    const {channelName} = useTrack();
    return (
        <div className="c-pagination">
            {pageCountDisplay}
            <div className="c-pagination_wrap">
                {hasPreviousPage &&
                    <a
                        href={previousPageUrl}
                        className="c-pagination_btn c-pagination--prev"
                        rel="nofollow"
                        onClick={() => trackPagingPrevious(channelName)}
                    >
                        <img src={mix("webfront/images/icon/arrow_left_white.svg")} width="14" height="6" alt=""/>
                        {translations.previous}
                    </a>
                }
                {hasNextPage &&
                    <a
                        href={nextPageUrl}
                        className="c-pagination_btn c-pagination--next"
                        rel="nofollow"
                        onClick={() => trackPagingNext(channelName)}
                    >
                        {translations.next}
                        <img src={mix("webfront/images/icon/arrow_right_white.svg")} width="14" height="6" alt=""/>
                    </a>
                }
            </div>
        </div>
    );
});

export const PaginationForNoResult = ({
    previousPageUrl,
    firstPageUrl,
    pageCountDisplay,
    translations,
}) => {
    const {channelName} = useTrack();
    return (
        <div className="c-pagination">
            {pageCountDisplay}
            <div className="c-pagination_wrap c-pagination_ver2">
                <a href={previousPageUrl} className="c-link" onClick={() => trackPagingPrevious(channelName)}>
                    <img src={mix("webfront/images/icon/arrow_left_gray.svg")} width="14" height="6" alt="" />
                    {translations.previous}
                </a>
                <a href={firstPageUrl} className="c-pagination_btn c-pagination--next">
                    {translations.back_to_page_one}
                </a>
            </div>
        </div>
    );
}
